import {
    BackspaceOutlined as BackspaceOutlinedIcon,
    DeleteForeverOutlined as DeleteForeverOutlinedIcon,
    EditTwoTone as EditTwoToneIcon,
    Search as SearchIcon,
    VisibilityOutlined as VisibilityOutlinedIcon
} from '@material-ui/icons';
import {
    Button,
    Card,
    CardContent,
    Input,
    MenuItem,
    Paper,
    Select,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TablePagination,
    TableRow,
    Tooltip
} from '@material-ui/core';
import { ANAO, ASIM } from 'consts';
import api from '../../../services/api';
import { Link } from 'react-router-dom';
import React, { Component } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import AlertInformation from 'components/AlertInformation/AlertInformation';
import DeleteConfirmationModal from '../../../components/DeleteConfirmationModal/DeleteConfirmationModal';

class MarcaVeiculoList extends Component {
    state = {
        searchFilter: JSON.parse(sessionStorage.getItem('marcaveiculoSearchFilter')) || {
            descmarcaveiculo: '',
            situacaoInativoFilter: ANAO
        },
        marcasveiculos: [],
        open: false,
        openAlert: false,
        messageAlert: '',
        selectedId: null,
        selectedDesc: null,
        totalItems: 0,
        page: Number(sessionStorage.getItem('marcaveiculoPage')) || 0,
        rowsPerPage: Number(sessionStorage.getItem('marcaveiculoRowsPerPage')) || 10
    };

    estilo = {
        redText: { color: 'red' },
        addButton: {
            height: '42px',
            display: 'flex',
            alignItems: 'center'
        },
        iconGroup: {
            display: 'inline-flex',
            gap: 5
        },
        actionIcon: {
            fontSize: 24,
            color: '#3f51b5',
            cursor: 'pointer'
        },
        marginTop: 30,
        marginLeft: 30,
        marginRight: 30
    };

    /* Altera a cor do ícone ao passar o cursor */
    handleIconMouseEnter = (event) => {
        event.currentTarget.style.color = '#2979ff';
    };

    /* Retorna à cor padrão do ícone ao remover o cursor */
    handleIconMouseLeave = (event) => {
        event.currentTarget.style.color = '#3f51b5';
    };

    /* Altera a cor do ícone de exclusão ao passar o cursor */
    handleDeleteIconMouseEnter = (event) => {
        event.currentTarget.style.color = 'red';
    };

    /* Carrega os dados iniciais da tela */
    async componentDidMount() {
        this.loadMarcasVeiculo();
    };

    /* Paginação */
    componentDidUpdate(prevProps, prevState) {
        const { page, rowsPerPage, searchFilter } = this.state;

        // persiste os filtros e a paginação no sessionStorage
        if (prevState.searchFilter !== searchFilter) {
            sessionStorage.setItem('marcaveiculoSearchFilter', JSON.stringify(searchFilter));
        }

        if (prevState.page !== page) {
            sessionStorage.setItem('marcaveiculoPage', page);
        }

        if (prevState.rowsPerPage !== rowsPerPage) {
            sessionStorage.setItem('marcaveiculoRowsPerPage', rowsPerPage);
        }
    };

    /* Limpa os filtros e a paginação ao sair da tela */
    componentWillUnmount() {
        sessionStorage.removeItem('marcaveiculoSearchFilter');
        sessionStorage.removeItem('marcaveiculoPage');
        sessionStorage.removeItem('marcaveiculoRowsPerPage');
    };

    /* Carrega as marcas de veículo */
    loadMarcasVeiculo = async () => {
        const { searchFilter, page, rowsPerPage } = this.state;
        const { descmarcaveiculo, situacaoInativoFilter } = searchFilter;

        let params = `?page=${page + 1}&limit=${rowsPerPage}`;

        if (descmarcaveiculo) {
            params += `&DESCMARCAVEICULO=_like_${descmarcaveiculo}`;
        }

        if (situacaoInativoFilter === ASIM || situacaoInativoFilter === ANAO) {
            params += `&INATIVO=${situacaoInativoFilter}`;
        }

        try {
            const response = await api.get('/marcaveiculo' + params);

            this.setState({
                marcasveiculos: response.data.data || [],
                totalItems: parseInt(response.data.info && response.data.info.totalrecords, 10) || 0
            });
        } catch (error) {
            console.error('Erro ao carregar marcas de veículos:', error);

            this.setState({
                marcasveiculos: [],
                totalItems: 0
            });
        }
    };

    /* Muda a página */
    handleChangePage = (event, newPage) => {
        this.setState({ page: newPage }, this.loadMarcasVeiculo);
    };

    /* Muda a quantidade de retornos por página */
    handleChangeRowsPerPage = (event) => {
        this.setState({
            rowsPerPage: parseInt(event.target.value, 10),
            page: 0
        }, this.loadMarcasVeiculo);
    };

    /* Deleta a marca de veículo */
    handleDelete = async (id) => {
        try {
            const response = await api.delete(`/marcaveiculo/${id}`);

            // verifica se a exclusão foi bem-sucedida
            if (response.status === 200) {
                this.handleClose();
                this.loadMarcasVeiculo();
            }
        } catch (error) {
            this.handleClose();

            this.handleOpenAlert(
                error.response?.data?.error ||
                error.response?.data?.message ||
                'Erro ao excluir marca de veículo!'
            );
        }
    };

    /* Confirma a exclusão */
    handleConfirmDelete = () => {
        const { selectedId } = this.state;

        this.handleDelete(selectedId);
    };

    /* Abre a janela de confirmação para a exclusão */
    handleOpen = (codmarcaveiculo, descmarcaveiculo) => {
        this.setState({
            open: true,
            selectedId: codmarcaveiculo,
            selectedDesc: descmarcaveiculo
        });
    };

    /* Abre a janela de alerta com mensagem */
    handleOpenAlert = (message) => {
        this.setState({
            openAlert: true,
            messageAlert: message
        });
    };

    /* Fecha a janela de confirmação da exclusão */
    handleClose = () => {
        this.setState({
            open: false,
            selectedId: null,
            selectedDesc: ''
        });
    };

    /* Fecha a janela de mensagem alerta */
    handleCloseAlert = () => {
        this.setState({ openAlert: false });
    };

    /* Pesquisa os filtros na tela */
    onChangeSearch = (event) => {
        const { name, value } = event.target;

        const searchFilter = {
            ...this.state.searchFilter,
            [name]: (typeof value === 'string') ? value.toUpperCase() : value
        };

        this.setState({
            searchFilter,
            page: 0
        });
    };

    /* Limpa os filtros da tela */
    limpaFiltros = () => {
        const searchFilter = {
            descmarcaveiculo: '',
            situacaoInativoFilter: ANAO
        };

        this.setState({
            searchFilter,
            page: 0
        }, this.loadMarcasVeiculo);
    };

    render() {
        const {
            marcasveiculos,
            messageAlert,
            open,
            openAlert,
            page,
            rowsPerPage,
            searchFilter,
            selectedDesc,
            selectedId,
            totalItems
        } = this.state;

        const {
            actionIcon,
            addButton,
            iconGroup,
            redText
        } = this.estilo;

        return (
            <div style={this.estilo}>
                <Paper
                    hover
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        flexWrap: 'wrap',
                        padding: '10px 20px',
                        width: '100%',
                        gap: 15
                    }}
                >
                    <Input
                        autoFocus
                        id="descmarcaveiculo"
                        name="descmarcaveiculo"
                        onBlur={this.onInputBlur}
                        onChange={this.onChangeSearch}
                        placeholder="Marca"
                        value={searchFilter.descmarcaveiculo}
                        style={{
                            flex: '0 1 200px',
                            minWidth: 200
                        }}
                    />

                    <Select
                        id="situacaoInativoFilter"
                        name="situacaoInativoFilter"
                        value={searchFilter.situacaoInativoFilter || ''}
                        onChange={this.onChangeSearch}
                        style={{
                            flex: '0 1 100px',
                            minWidth: 100,
                            textAlign: 'center'
                        }}
                    >
                        <MenuItem
                            value={ANAO}
                            style={{ justifyContent: 'center' }}
                        >
                            Ativos
                        </MenuItem>

                        <MenuItem
                            value={ASIM}
                            style={{ justifyContent: 'center' }}
                        >
                            Inativos
                        </MenuItem>

                        <MenuItem
                            value={'T'}
                            style={{ justifyContent: 'center' }}
                        >
                            Todos
                        </MenuItem>
                    </Select>

                    <span style={iconGroup}>
                        <Tooltip title="Procurar">
                            <SearchIcon
                                onClick={this.loadMarcasVeiculo}
                                onMouseEnter={this.handleIconMouseEnter}
                                onMouseLeave={this.handleIconMouseLeave}
                                style={actionIcon}
                            />
                        </Tooltip>

                        <Tooltip title="Limpar">
                            <BackspaceOutlinedIcon
                                onClick={this.limpaFiltros}
                                onMouseEnter={this.handleIconMouseEnter}
                                onMouseLeave={this.handleIconMouseLeave}
                                style={actionIcon}
                            />
                        </Tooltip>
                    </span>

                    <div style={{ flex: 1 }} />

                    <Button
                        component={Link}
                        to="/frotas/marcaveiculo/novo"
                        variant="contained"
                        color="primary"
                        style={addButton}
                    >
                        Novo
                    </Button>
                </Paper>

                <br />

                <Card>
                    <CardContent>
                        <PerfectScrollbar>
                            <div>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align="center">Código</TableCell>

                                            <TableCell align="center">Descrição</TableCell>

                                            <TableCell align="center">Ações</TableCell>
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {marcasveiculos.length === 0 && (
                                            <TableRow>
                                                <TableCell
                                                    align="center"
                                                    colSpan={3}
                                                >
                                                    Nenhuma marca de veículo encontrada
                                                </TableCell>
                                            </TableRow>
                                        )}

                                        {marcasveiculos.map(marcaveiculo => (
                                            <TableRow
                                                hover
                                                key={marcaveiculo.codmarcaveiculo}
                                            >
                                                <TableCell
                                                    align="center"
                                                    style={(marcaveiculo.inativo === ASIM) ? redText : {}}
                                                >
                                                    {marcaveiculo.codmarcaveiculo}
                                                </TableCell>

                                                <TableCell
                                                    align="center"
                                                    style={(marcaveiculo.inativo === ASIM) ? redText : {}}
                                                >
                                                    {marcaveiculo.descmarcaveiculo}
                                                </TableCell>

                                                <TableCell align="center">
                                                    <span style={iconGroup}>
                                                        <Tooltip title="Editar">
                                                            <Link to={`/frotas/marcaveiculo/${marcaveiculo.codmarcaveiculo}`}>
                                                                <EditTwoToneIcon
                                                                    onMouseEnter={this.handleIconMouseEnter}
                                                                    onMouseLeave={this.handleIconMouseLeave}
                                                                    style={actionIcon}
                                                                />
                                                            </Link>
                                                        </Tooltip>

                                                        <Tooltip title="Visualizar">
                                                            <Link to={`/frotas/marcaveiculo/${marcaveiculo.codmarcaveiculo}/view`}>
                                                                <VisibilityOutlinedIcon
                                                                    onMouseEnter={this.handleIconMouseEnter}
                                                                    onMouseLeave={this.handleIconMouseLeave}
                                                                    style={actionIcon}
                                                                />
                                                            </Link>
                                                        </Tooltip>

                                                        <Tooltip title="Excluir">
                                                            <DeleteForeverOutlinedIcon
                                                                onClick={() => this.handleOpen(
                                                                    marcaveiculo.codmarcaveiculo,
                                                                    marcaveiculo.descmarcaveiculo
                                                                )}
                                                                onMouseEnter={this.handleDeleteIconMouseEnter}
                                                                onMouseLeave={this.handleIconMouseLeave}
                                                                style={actionIcon}
                                                            />
                                                        </Tooltip>
                                                    </span>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </div>
                        </PerfectScrollbar>

                        <TablePagination
                            component="div"
                            count={totalItems}
                            onPageChange={this.handleChangePage}
                            onRowsPerPageChange={this.handleChangeRowsPerPage}
                            page={page}
                            rowsPerPage={rowsPerPage}
                            rowsPerPageOptions={[10, 50, 100, 200]}
                            labelRowsPerPage="Registros por página"
                        />
                    </CardContent>
                </Card>

                <DeleteConfirmationModal
                    open={open}
                    itemId={selectedId}
                    message={`Confirma exclusão da marca de veículo ${selectedDesc || ''} [${selectedId}]?`}
                    handleClose={this.handleClose}
                    handleDelete={this.handleConfirmDelete}
                />

                <AlertInformation
                    open={openAlert}
                    message={messageAlert}
                    handleClose={this.handleCloseAlert}
                />
            </div>
        );
    }
};

export default MarcaVeiculoList;